export const clearGlobalLoading = ({ setLoading, setNavigationLoading }) => {
    setLoading(false);
    setNavigationLoading(false);
};

export const createHttpErrorHandler = ({
    Swal,
    router,
    store,
    translate,
    setLoading,
    setNavigationLoading,
}) => {
    let authErrorPromise = null;
    let forbiddenErrorPromise = null;

    const resetLoading = () =>
        clearGlobalLoading({ setLoading, setNavigationLoading });

    return async ({ status, message }) => {
        if (status === 401) {
            if (!authErrorPromise) {
                authErrorPromise = (async () => {
                    try {
                        resetLoading();
                        await store.dispatch('auth/signout');

                        const result = await Swal.fire({
                            title: translate(
                                'django.system_msg__status_code_401',
                                'Unauthorized'
                            ),
                            text:
                                message ||
                                translate(
                                    'django.system_msg__session_expired',
                                    'Authentication has expired. Please sign in again.'
                                ),
                            icon: 'error',
                            confirmButtonText: translate(
                                'users.users_msg__verification_button',
                                'OK'
                            ),
                        });

                        if (
                            result.isConfirmed &&
                            router.currentRoute.value.path !== '/'
                        ) {
                            await router.push('/');
                        }
                    } finally {
                        authErrorPromise = null;
                    }
                })();
            }

            return authErrorPromise;
        }

        if (status === 403) {
            if (!forbiddenErrorPromise) {
                forbiddenErrorPromise = (async () => {
                    try {
                        resetLoading();
                        await Swal.fire({
                            title: translate(
                                'django.system_msg__status_code_403',
                                'Forbidden'
                            ),
                            text: translate(
                                'django.system_msg__forbidden_page_access',
                                'You do not have permission to access this page'
                            ),
                            icon: 'error',
                            confirmButtonText: translate(
                                'users.users_msg__verification_button',
                                'OK'
                            ),
                        });

                        if (router.currentRoute.value.path !== '/') {
                            await router.push('/');
                        }
                    } finally {
                        forbiddenErrorPromise = null;
                    }
                })();
            }

            return forbiddenErrorPromise;
        }

        if (status >= 500) {
            await Swal.fire({
                title: translate(
                    'django.system_msg__internal_server_error',
                    'Internal server error'
                ),
                text:
                    message ||
                    translate(
                        'django.system_msg__please_try_again_later',
                        'Please try again later'
                    ),
                icon: 'error',
                confirmButtonText: translate(
                    'users.users_msg__verification_button',
                    'OK'
                ),
            });
            return;
        }

        if (status >= 400 && status < 500) {
            return;
        }

        await Swal.fire({
            title: translate(
                'django.system_msg__network_error',
                'Network error'
            ),
            text: translate(
                'django.system_msg__network_error_try_again_later',
                'Unable to reach the server, please try again later.'
            ),
            icon: 'error',
            confirmButtonText: translate(
                'users.users_msg__verification_button',
                'OK'
            ),
        });
    };
};
